import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';
import { Link } from 'react-router-dom';


const EditQA = ({qaId, list}) => {
    const [qaData, setQAData] = useState(null);
    const [taskIncharge, setTaskIncharge] = useState([]);
    const [assignedTester, setAssignedTester] = useState([]);
    const [getstatus, setStatus] = useState([]);
    
    const [defaultBrowsers, setDefaultBrowsers] = useState([]);

    const fetchQAs = async (Id) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/qa/${Id}`)
        .then(response => {
            setQAData(response.data.data);
            setDefaultBrowsers(response.data.data.browsers || []);
        })
        .catch(error => {
            console.log(error);
            setQAData([]); 
            setDefaultBrowsers([]);
        });
    }

    const fetchData = async () => {
        try {
            const teamleadsRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=teamleads`);
            setTaskIncharge(teamleadsRes.data.data);

            const testerRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=all`);
            setAssignedTester(testerRes.data.data);

            const qaStatusRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/qa_status`);
            setStatus(qaStatusRes.data.data);

        } catch (error) {
            console.error("Error fetching data!", error);
            setTaskIncharge([]); setAssignedTester([]); setStatus([]);
        }
    };

    useEffect(() => {
        if(qaId){
            fetchQAs(qaId);
        }
        fetchData();
    }, [qaId]);


    const schema = Yup.object().shape({
        task_incharge_id: Yup.string().required('manager/teamlead is a required field'),
        assigned_tester_id: Yup.string().required('assign tester is a required field'),
        description: Yup.string().required(),
        browsers: Yup.array().nullable().typeError('please select at least one browser')
                    .min(1, 'please select at least one browser').required()
    });
    
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (qaData) {
            reset(qaData);
            setDefaultBrowsers(qaData.browsers || []);
        }
    }, [qaData, reset]);


    const handleBrowserChange = (br, isChecked) => {
        if (isChecked) {
            setDefaultBrowsers([...defaultBrowsers, br]);
        } else {
            setDefaultBrowsers(defaultBrowsers.filter(browser => browser !== br));
        }
    }

    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append('_method', 'patch');

        Object.keys(data).forEach(key => {
            if (key === 'attachment') {
                Array.from(data[key]).forEach((file, index) => {
                    formData.append(`${key}[${index}]`, file);
                });
            }
            else {
                formData.append(key, data[key]);
            }
        });

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/qa/${qaId}`, formData)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_qa_${qaId}`);
                list();
            })
            .catch(error => {
                Swal.fire({text:error, icon:"error"});
                console.error('Error updating qa', error);
            });
    }

    if (!qaId || !qaData) {
        return null;
    }

    return (
        <div id={`edit_qa_${qaId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Manage QA</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel</label>
                                        <input type='text' disabled className="form-control" defaultValue={qaData.channel || ""} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client</label>
                                        <input type='text' disabled className="form-control" defaultValue={qaData.client || ""} />                                       
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project</label>
                                        <input type='text' disabled className="form-control" defaultValue={qaData.project_name || ""} />                                       
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Select Manager/Team Lead<span className="text-danger">*</span></label>
                                        <select className="form-control" defaultValue={qaData.task_incharge_id || ""} {...register('task_incharge_id')}>
                                            <option value="">Select Manager/Team Lead</option>
                                            {taskIncharge.map(incharge => (
                                                <option key={incharge.id} value={incharge.id}>{incharge.name} ({incharge.designation})</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.task_incharge_id && <p>{errors.task_incharge_id.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Assign Tester <span className="text-danger">*</span></label>
                                        <select className="form-control" defaultValue={qaData.assigned_tester_id || ""} {...register('assigned_tester_id')}>
                                            <option value="">Select Assign Tester</option>
                                            {assignedTester.filter(tester => tester.department === 'Testing').map(tester => (
                                                <option key={tester.id} value={tester.id}>{tester.name}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.assigned_tester_id && <p>{errors.assigned_tester_id.message}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Description <span className="text-danger">*</span></label>
                                        <textarea className="form-control" defaultValue={qaData.description || ""} {...register('description')}  rows={3}></textarea>
                                        <div className="text-sm text-danger">
                                            {errors.description && <p>{errors.description.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Attachment </label>
                                        <input className="form-control" type="file" {...register('attachment')} multiple/>                                        
                                    </div>
                                    {qaData.attachment ? qaData.attachment.map((file, index) => (
                                        <div key={index}>
                                            <Link to={`${process.env.REACT_APP_API_FILE_URL}/${file}`} className="btn btn-secondary btn-sm mb-3" target="_blank" rel="noopener noreferrer">
                                                Document {++index}
                                            </Link>
                                            <br />
                                        </div>                                        
                                        )) : ""
                                    }
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Status </label>
                                        <select className="form-control" defaultValue={qaData.status || ""} {...register('status')}>
                                            {getstatus.map(status => (
                                                <option key={status.id} value={status.id}>{status.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Browsers <span className="text-danger">*</span></label>
                                        <div className="checkbox">
                                            {['Firefox', 'Chrome', 'IE', 'Safari', 'Edge', 'Responsive', 'Android', 'IOS', 'Android tablet', 'Ipad'].map(browser => (
                                                <label key={browser} className="col-form-label" style={{ marginRight: '15px' }}>
                                                    <input
                                                        type="checkbox"
                                                        value={browser}
                                                        {...register('browsers')}
                                                        onChange={(e) => handleBrowserChange(browser, e.target.checked)}
                                                        checked={defaultBrowsers.includes(browser)}
                                                    /> {browser}
                                                </label>
                                            ))}
                                        </div>

                                        <div className="text-sm text-danger">
                                            {errors.browsers && <p>{errors.browsers.message}</p>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditQA